// Pembungkus timeout untuk Promise jaringan.
//
// supabase-js (fetch) TIDAK punya timeout default: bila koneksi menggantung
// (jaringan lambat / cold start), promise-nya tak pernah resolve MAUPUN reject,
// sehingga gate `loading` layar-penuh macet `true` selamanya → seluruh layar
// jadi skeleton & semua tombol terasa "freeze". `withTimeout` me-reject promise
// setelah `ms` agar blok catch/finally pemanggil tetap jalan (loading dilepas,
// pesan error + tombol "Coba lagi" muncul). Bandingkan safety-net 6 dtk di
// OrderBoard yang menambal gejala yang sama.

export class TimeoutError extends Error {
  constructor(
    message = "Koneksi terlalu lama merespons. Periksa internet lalu coba lagi."
  ) {
    super(message);
    this.name = "TimeoutError";
  }
}

export const DEFAULT_TIMEOUT_MS = 12000;

// Menerima `PromiseLike` agar query-builder Supabase (thenable, bukan Promise
// asli) bisa dibungkus langsung tanpa harus di-`await` dulu.
export function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number = DEFAULT_TIMEOUT_MS,
  message?: string
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new TimeoutError(message)), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      }
    );
  });
}
